import { ApiResult } from "../shared/networking/api_result";
import { getConfig } from "./config.service";
import { ISofwareVersion } from "models/site_information";
import HttpService from "../shared/networking/http_service";

class EnvironmentServiceAPI extends HttpService {
  public async getSoftwareVersion(): Promise<ApiResult<ISofwareVersion>> {
    return this.get(`/${appConfig.apiUrl}/environment/information`);
  }
}

const appConfig = getConfig();
const TimeoutMilliseconds = Number(appConfig.httpTimeoutMs);
const EnvironmentService = new EnvironmentServiceAPI(TimeoutMilliseconds);

export default EnvironmentService;
